<template>
  <div class="mb-0">
    <!-- Automatic mo-fetch sa current active route meta -->
    <h5 class="page-panel-title">{{ headerTitle }}</h5>
    <p v-if="headerSubtitle" class="page-panel-subtitle">{{ headerSubtitle }}</p>
  </div>
</template>

<script>
 /* eslint-disable */
export default {
  name: 'PanelHeader',
  computed: {
    headerTitle() {
      return this.$route.meta.title || '';
    },
    headerSubtitle() {
      return this.$route.meta.sub_title || '';
    }
  }
}
</script>

<style scoped>
.page-panel-title {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  color: #1e293b !important;
  margin-bottom: 1px !important;
  line-height: 1.2 !important;
}

.page-panel-subtitle {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #64748b !important;
  margin-bottom: 0 !important;
  line-height: 1.4 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/core/PanelHeader.vue